// Google API Key
export const GOOGLE_API_KEY = 'AIzaSyD0t-0fo0H04SnSxGAzeQ-0pXrkWNm2XuU';

// OpenLayers
export const OL_DEFAULT_CENTER = { lat: 37.55, lng: 127.05 };
export const OL_DEFAULT_ZOOM = 17;

// 3rd Party APIs
export const GOOGLE_GEOCODING_URL = 'https://maps.googleapis.com/maps/api/geocode/json';

// Mission
export const SAFETY_MARGIN = 10;

// Survey
export const SURVEY_DEFAULT_OPTIONS = {
  entryIndex: 0,
  gap: 10,
  rotate: 0,
  turnaround: { before: 0, after: 0 },
  segment: null,
  camera: null,
};
export const SURVEY_ENTRIES = [
  'bottom left',
  'top left',
  'top right',
  'bottom right',
];
export const SURVEY_GAP_MIN = 2;
export const SURVEY_GAP_MAX = 500;
export const SURVEY_TURNAROUND_MIN = 0;
export const SURVEY_TURNAROUND_MAX = 1000;
export const SURVEY_AREA_MAX = 200000000; // 200km²

// Fence
export const FENCE_CIRCLE_RADIUS_MIN = 10;
export const FENCE_POLYGON_AREA_MIN = 100; // 100m²

// Camera Shoot
export const SHOOT_OVERLAP_DEFAULT_OPTIONS = {
  forward: 10,
  side: 10,
};
export const SHOOT_OVERLAP_MIN = 0;
export const SHOOT_OVERLAP_MAX = 99;
export const SHOOT_INTERVAL = 25;
